import { Button, Col, Form, Input, Row, Select } from 'antd';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { specialStateSelector } from 'utils/tools/slice-actions';
import { selectLandingPageSlice } from '../slice/selectors';
import { LandingPageActionTypes, useLandingPageSlice } from '../slice';
import PhoneInput from 'modules/common/FormItems/PhoneInput';
import { isMobile } from 'react-device-detect';

export default function ContactForm({ isForDemo = false, demoFormSubmitted }) {
  const [form] = Form.useForm();

  const { loading, data, error } = useSelector(
    specialStateSelector(
      selectLandingPageSlice,
      LandingPageActionTypes.SUBMIT_CALLBACK,
    ),
  );

  const { actions } = useLandingPageSlice();
  const dispatch = useDispatch();

  const submitCallback = useCallback(values => {
    const payload = {
      ...values,
      enquiry_type: 'callback',
      constituency_location: { address1: values.constituency_location },
    };

    dispatch(
      actions.submitCallbackStart({
        actionFor: LandingPageActionTypes.SUBMIT_CALLBACK,
        ...payload,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    !loading && !error && form.resetFields();
    isForDemo && data && !loading && !error && demoFormSubmitted(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data]);

  const interestTypes = useMemo(
    () => [
      {
        value: 'I want to request a demo.',
        label: 'I want to request a demo.',
      },
      {
        value: `I'm interested in becoming a partner.`,
        label: `I'm interested in becoming a partner.`,
      },
      {
        value: `I'd like to talk to one of your customers.`,
        label: `I'd like to talk to one of your customers.`,
      },
    ],
    [],
  );

  return (
    <>
      <Form
        form={form}
        name="request-callback"
        scrollToFirstError
        layout="vertical"
        onFinish={submitCallback}
      >
        <Row gutter={16}>
          <Col xs={24} lg={12}>
            <Form.Item
              name="first_name"
              label="First Name"
              rules={[
                { type: 'text' },
                {
                  required: true,
                  message: 'Please enter a First Name!',
                },
                {
                  whitespace: true,
                  message: 'White spaces not allowed!',
                },
              ]}
            >
              <Input placeholder="First Name" maxLength="50" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={12}>
            <Form.Item
              name="last_name"
              label="Last Name"
              rules={[
                { type: 'text' },
                {
                  required: true,
                  message: 'Please enter a Last Name!',
                },
                {
                  whitespace: true,
                  message: 'White spaces not allowed!',
                },
              ]}
            >
              <Input placeholder="Last Name" maxLength="50" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} lg={12}>
            <Form.Item
              name="email_id"
              label="E-mail"
              rules={[
                {
                  type: 'email',
                  message: 'The is not a valid E-mail ID!',
                },
                {
                  required: true,
                  message: 'Please enter an E-mail ID!',
                },
                {
                  whitespace: true,
                  message: 'White spaces not allowed!',
                },
              ]}
            >
              <Input placeholder="abc@xyz.com" maxLength="100" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={12} style={{ width: '100%' }}>
            <PhoneInput
              mobile={null}
              mobile_country_code={null}
              formLabel="Mobile"
              mobileItemName="mobile_number"
            />
          </Col>
        </Row>
        {!isForDemo && (
          <>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item
                  name="constituency_name"
                  label="Name of the business"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter business name!',
                    },
                    {
                      whitespace: true,
                      message: 'White spaces not allowed!',
                    },
                  ]}
                >
                  <Input placeholder="Enter your business name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} lg={24}>
                <Form.Item
                  name="constituency_location"
                  label="Location of the business"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the business location!',
                    },
                  ]}
                >
                  <Input placeholder="R K Puram, New Delhi" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} lg={24}>
                <Form.Item
                  name="your_interest"
                  label="Your Interest"
                  rules={[
                    {
                      required: true,
                      message: 'Please select your interest!',
                    },
                  ]}
                >
                  <Select
                    // allowClear
                    // showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input?.trim()?.toLowerCase())
                    }
                    placeholder="Select your interest"
                  >
                    {interestTypes.map(el => (
                      <Select.Option key={el.value} value={el.value}>
                        {el.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
        <Form.Item style={{ textAlign: 'center' }}>
          <Button
            style={{
              width: isMobile ? '100%' : '200px',
            }}
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
